import React ,{useEffect} from 'react';
import AOS from 'aos';
import Header from '../Components/Shared/Header/Header';
import Banner from '../Components/Pages/Front/Banner';
import Container from '../Components/Pages/Front/Container';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
function Front(){
    useEffect(() => {
        AOS.init({
          duration: 800,
          disable: 'mobile',
          once: true,
        });
      }, []);
    return(
        <>
        <Header />
        <Banner />
        <Container />
        <Start />
        <Footer />
        </>
    )
};
export default Front ;